var bundleSuggestionMap = {
    "KB1-JY201M-001": {
        title: "Your customised shorts",
        subtitle: "From $39.90",
        designUrl: "#/customise/65898965"
    },
    "KB1-JY201M-002": {
        title: "Your customised shorts",
        subtitle: "From $39.90",
        designUrl: "#/customise/65899070"
    },
    "KB1-JY201M-003": {
        title: "Your customised shorts",
        subtitle: "From $39.90",
        designUrl: "#/customise/65710110"
    },
    "KB1-JY201M-004": {
        title: "Your customised shorts",
        subtitle: "From $39.90",
        designUrl: "#/customise/65898567"
    },
    "KB1-JY201M-005": {
        title: "Your customised shorts",
        subtitle: "From $39.90",
        designUrl: "#/customise/65832712"
    },
    "KB1-JY201M-006": {
        title: "Your customised shorts",
        subtitle: "From $39.90",
        designUrl: "#/customise/65831098"
    },
    "KB1-JY201M-007": {
        title: "Your customised shorts",
        subtitle: "From $39.90",
        designUrl: "#/customise/65708295"
    },
    "KB1-JY201M-008": {
        title: "Your customised shorts",
        subtitle: "From $39.90",
        designUrl: "#/customise/65717073"
    },
    "KB1-JY201M-009": {
        title: "Your customised shorts",
        subtitle: "From $39.90",
        designUrl: "#/customise/65832410"
    },
    "KB1-JY201M-010": {
        title: "Your customised shorts",
        subtitle: "From $39.90",
        designUrl: "#/customise/65831104"
    },
    "KB1-JY201M-011": {
        title: "Your customised shorts",
        subtitle: "From $39.90",
        designUrl: "#/customise/65831103"
    },
    "KB1-JY201M-012": {
        title: "Your customised shorts",
        subtitle: "From $39.90",
        designUrl: "#/customise/65831102"
    },
    "KB1-JY201M-013": {
        title: "Your customised shorts",
        subtitle: "From $39.90",
        designUrl: "#/customise/65831101"
    },
    "KB1-JY201M-014": {
        title: "Your customised shorts",
        subtitle: "From $39.90",
        designUrl: "#/customise/65831100"
    },
    "KB1-JY201M-015": {
        title: "Your customised shorts",
        subtitle: "From $39.90",
        designUrl: "#/customise/65831099"
    },
    "KB1-JY201W-001": {
        title: "Your customised shorts",
        subtitle: "From $39.90",
        designUrl: "#/customise/65899066"
    },
    "KB1-JY201W-002": {
        title: "Your customised shorts",
        subtitle: "From $39.90",
        designUrl: "#/customise/65899071"
    },
    "KB1-JY201W-003": {
        title: "Your customised shorts",
        subtitle: "From $39.90",
        designUrl: "#/customise/65832418"
    },
    "KB1-JY201W-004": {
        title: "Your customised shorts",
        subtitle: "From $39.90",
        designUrl: "#/customise/65898568"
    },
    "KB1-JY201W-005": {
        title: "Your customised shorts",
        subtitle: "From $39.90",
        designUrl: "#/customise/65831096"
    },
    "KB1-JY201W-006": {
        title: "Your customised shorts",
        subtitle: "From $39.90",
        designUrl: "#/customise/65834428"
    },
    "KB1-JY201W-007": {
        title: "Your customised shorts",
        subtitle: "From $39.90",
        designUrl: "#/customise/65832411"
    },
    "KB1-JY201W-008": {
        title: "Your customised shorts",
        subtitle: "From $39.90",
        designUrl: "#/customise/65831105"
    },
    "KB1-JY201W-009": {
        title: "Your customised shorts",
        subtitle: "From $39.90",
        designUrl: "#/customise/65832713"
    },
    "KB1-JY201W-010": {
        title: "Your customised shorts",
        subtitle: "From $39.90",
        designUrl: "#/customise/65832412"
    },
    "KB1-JY201W-011": {
        title: "Your customised shorts",
        subtitle: "From $39.90",
        designUrl: "#/customise/65834429"
    },
    "KB1-JY201W-012": {
        title: "Your customised shorts",
        subtitle: "From $39.90",
        designUrl: "#/customise/65834430"
    },
    "KB1-JY201W-013": {
        title: "Your customised shorts",
        subtitle: "From $39.90",
        designUrl: "#/customise/65832413"
    },
    "KB1-JY201W-014": {
        title: "Your customised shorts",
        subtitle: "From $39.90",
        designUrl: "#/customise/65832414"
    },
    "KB1-JY201W-015": {
        title: "Your customised shorts",
        subtitle: "From $39.90",
        designUrl: "#/customise/65834431"
    },
    "KB1-JY201Y-001": {
        title: "Your customised shorts",
        subtitle: "From $39.90",
        designUrl: "#/customise/65898564"
    },
    "KB1-JY201Y-002": {
        title: "Your customised shorts",
        subtitle: "From $39.90",
        designUrl: "#/customise/65898966"
    },
    "KB1-JY201Y-003": {
        title: "Your customised shorts",
        subtitle: "From $39.90",
        designUrl: "#/customise/65832419"
    },
    "KB1-JY201Y-004": {
        title: "Your customised shorts",
        subtitle: "From $39.90",
        designUrl: "#/customise/65898967"
    },
    "KB1-JY201Y-005": {
        title: "Your customised shorts",
        subtitle: "From $39.90",
        designUrl: "#/customise/65831097"
    },
    "KB1-JY201Y-006": {
        title: "Your customised shorts",
        subtitle: "From $39.90",
        designUrl: "#/customise/65831106"
    },
    "KB1-JY201Y-007": {
        title: "Your customised shorts",
        subtitle: "From $39.90",
        designUrl: "#/customise/65832714"
    },
    "KB1-JY201Y-008": {
        title: "Your customised shorts",
        subtitle: "From $39.90",
        designUrl: "#/customise/65834432"
    },
    "KB1-JY201Y-009": {
        title: "Your customised shorts",
        subtitle: "From $39.90",
        designUrl: "#/customise/65831107"
    },
    "KB1-JY201Y-010": {
        title: "Your customised shorts",
        subtitle: "From $39.90",
        designUrl: "#/customise/65832715"
    },
    "KB1-JY201Y-011": {
        title: "Your customised shorts",
        subtitle: "From $39.90",
        designUrl: "#/customise/65832716"
    },
    "KB1-JY201Y-012": {
        title: "Your customised shorts",
        subtitle: "From $39.90",
        designUrl: "#/customise/65832717"
    },
    "KB1-JY201Y-013": {
        title: "Your customised shorts",
        subtitle: "From $39.90",
        designUrl: "#/customise/65832416"
    },
    "KB1-JY201Y-014": {
        title: "Your customised shorts",
        subtitle: "From $39.90",
        designUrl: "#/customise/65831108"
    },
    "KB1-JY201Y-015": {
        title: "Your customised shorts",
        subtitle: "From $39.90",
        designUrl: "#/customise/65832417"
    }
};

var onSuccessfulAddToCart = function(responseData) {
    $('body').trigger('gtm:added-to-cart');

    var sku = responseData.sku;

    var suggestion = bundleSuggestionMap[sku];
    var $popup = $('#added-to-cart-popup');
    $popup.find('.added-product').html(
        '<img src="'+responseData.image+'" alt="'+responseData.title+'"/>' +
        '<h4 class="text">'+responseData.title+'</h4>'
    );

    if (suggestion) {
        $popup.addClass('with-suggestion');

        $suggestedContainer = $popup.find('.suggested-product');
        $suggestedContainer.empty();
        
        if (suggestion.imageUrl) {
            $suggestedContainer.append($('<img src="'+suggestion.imageUrl+'" alt="'+suggestion.title+'"/>'));
        }

        var $text = $('<div><h4 class="text">'+suggestion.title+'</h4></div>');
        if (suggestion.subtitle) {
            $text.append($('<h6 class="text">'+suggestion.subtitle+'</h6>'))
        }
        $suggestedContainer.append($text);
        
        $popup.find('.suggested-product-link').on('click', function(e) {
            e.preventDefault();
            window.location.hash = suggestion.designUrl;
            window.location.reload();
        })

        $button1 = $('<a class="btn btn--primary close-popup suggested-product-link" href="">Continue</a>');
        $button2 = $('<a class="text-link close-popup" href="/cart">Skip to cart</a>');

        $button1.on('click', function(e) {
            e.preventDefault();
            window.location.hash = suggestion.designUrl;
            window.location.reload();
        });

        $popup.find('.buttons').empty().append($button1).append($button2);
    } else {
        $popup.removeClass('with-suggestion');

   var currentURL = window.location.href;
      console.log(currentURL);

if (currentURL.includes("/en-us")) {
  $button1 = $('<a class="btn btn--primary close-popup" href="/en-us/cart">View Cart</a>');
   $button2 = $('<a class="text-link close-popup" href="/en-us">Continue Shopping</a>');
   $popup.find('.buttons').empty().append($button1).append($button2);
} else {
  // Set the value of $button1 for other cases


        $button1 = $('<a class="btn btn--primary close-popup" href="/cart">View Cart</a>');

        $button2 = $('<a class="text-link close-popup" href="/">Continue Shopping</a>');
   $popup.find('.buttons').empty().append($button1).append($button2);
}
       
    }

    $.magnificPopup.open({
        items: {
            src: $popup
        },
        type: "inline",
        tClose: "Close",
        fixedContentPos: true,
        enableEscapeKey: false,
        closeOnContentClick: false,
        closeOnBgClick: false,
        callbacks: {
            open: function() {
                $(".close-popup").on("click", function() {
                    $.magnificPopup.close();
                });
            }
        }
    });
};

document.addEventListener("KitBuilderLoaded", function() {
    KitBuilder.init("#kitBuilder", {
        auth: {
            shopifyAppProxyUrl: "/a/kit-builder"
        },
        cartItemPricingMethod: "SimpleTieredPricing",
        currencySymbol: "$",
        currencySymbolAfter: "",
        cartType: "Shopify",
        customCallbacks: {
            webhookAddSingleItemToCartCallback: function(data) {
                console.log(data);
                var response = JSON.parse(data.content);
                if (response.variantId) {
                    var currentTime = (new Date()).toLocaleString(
                        [],
                        {
                            hour12: true,
                            hour: 'numeric',
                            minute: 'numeric',
                        }
                    );

                    var payload = {
                        id: response.variantId,
                        properties: {
                            Created: currentTime,
                        }
                    }

                    var shareLink = window.createKbShareLink && window.createKbShareLink(false);
                    if (shareLink) {
                        payload.properties['_Continue editing'] = shareLink;
                    }

                    $.post("/cart/add.js", payload, onSuccessfulAddToCart, 'json');
                }
            }
        }
    });
});


